import { render, staticRenderFns } from "./DebitCard.vue?vue&type=template&id=0c6a9d58&scoped=true"
import script from "./DebitCard.vue?vue&type=script&lang=js"
export * from "./DebitCard.vue?vue&type=script&lang=js"
import style0 from "./DebitCard.vue?vue&type=style&index=0&id=0c6a9d58&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c6a9d58",
  null
  
)

export default component.exports